import { useEffect, useState } from 'react';

export default function AboutUs() {
  const [counters, setCounters] = useState({ countries: 0, growth: 0 });

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    let step = 0;
    const timer = setInterval(() => {
      step++;
      const progress = step / steps;
      setCounters({
        countries: Math.floor(13 * progress),
        growth: Math.floor(239 * progress)
      });

      if (step >= steps) {
        clearInterval(timer);
        setCounters({ countries: 13, growth: 239 });
      }
    }, interval);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="scroll-animate py-32 bg-white">
      <div className="max-w-7xl mx-auto px-20">
        {/* Split layout */}
        <div className="flex items-center gap-20 mb-20">
          {/* Left 50%: Text content */}
          <div className="w-1/2">
            <h2 className="text-5xl font-bold text-slate-900 mb-8">
              Who We Are
            </h2>
            <div className="text-lg text-slate-600 leading-relaxed space-y-6">
              <p>
                ONSQUARE INC. is a venture-certified technology company building AI-powered platforms that help businesses expand globally. We specialize in creating solutions that bridge language barriers, automate complex workflows, and connect people across borders.
              </p>
              <p>
                Founded with a vision to democratize global business access, we combine cutting-edge AI technology with deep understanding of international markets. Our platforms serve thousands of users across 13 countries, from individual consultants to enterprise clients.
              </p>
              <p>
                We believe technology should empower everyone to participate in the global economy, regardless of location or resources. That's why we build tools that are powerful yet accessible, sophisticated yet intuitive.
              </p>
            </div>
          </div>

          {/* Right 50%: Isometric illustration */}
          <div className="w-1/2">
            <img 
              src="https://public.readdy.ai/ai/img_res/1f4cb3719a1555eaba447e879880df19.jpg"
              alt="Team collaboration"
              className="w-full h-auto drop-shadow-xl"
            />
          </div>
        </div>

        {/* Bottom: 3 Cards with gradient backgrounds */}
        <div className="grid grid-cols-3 gap-8">
          {/* Card 1: Countries */}
          <div className="relative bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-8 text-white overflow-hidden group hover:scale-105 transition-transform duration-300 cursor-pointer">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full -mr-16 -mt-16"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className="ri-global-line text-5xl animate-pulse"></i>
              </div>
              <div className="text-5xl font-bold mb-2">{counters.countries}</div>
              <div className="text-xl font-semibold mb-3">Countries</div>
              <div className="text-sm opacity-90">Global network spanning across continents</div>
              <div className="mt-4 flex gap-1">
                {[...Array(13)].map((_, i) => (
                  <div key={i} className="w-2 h-2 bg-white rounded-full opacity-60"></div>
                ))}
              </div>
            </div>
          </div>

          {/* Card 2: Growth */}
          <div className="relative bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 text-white overflow-hidden group hover:scale-105 transition-transform duration-300 cursor-pointer">
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-white opacity-10 rounded-full -ml-20 -mb-20"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-5xl animate-bounce"></i>
              </div>
              <div className="text-5xl font-bold mb-2">{counters.growth}%</div>
              <div className="text-xl font-semibold mb-3">Growth Rate</div>
              <div className="text-sm opacity-90">Year-over-year revenue expansion</div>
              <div className="mt-4 flex items-end gap-1 h-12">
                {[20, 35, 45, 60, 80, 100].map((height, i) => (
                  <div key={i} className="flex-1 bg-white rounded-t" style={{ height: `${height}%` }}></div>
                ))}
              </div>
            </div>
          </div>

          {/* Card 3: Certification */}
          <div className="relative bg-gradient-to-br from-purple-500 to-indigo-600 rounded-2xl p-8 text-white overflow-hidden group hover:scale-105 transition-transform duration-300 cursor-pointer">
            <div className="absolute top-1/2 right-0 w-32 h-32 bg-white opacity-10 rounded-full -mr-16"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-5xl animate-pulse"></i>
              </div>
              <div className="text-3xl font-bold mb-2">Venture</div>
              <div className="text-xl font-semibold mb-3">Certified</div>
              <div className="text-sm opacity-90">Official recognition for innovation excellence</div>
              <div className="mt-4 flex items-center gap-2">
                <div className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-xl"></i>
                </div>
                <div className="text-xs opacity-75">Verified Status</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
